import axios from 'axios';
//import AuthService from './utility/authenticationService';

const adminInstance = axios.create({
    //baseURL: process.env.REACT_APP_ADMIN_BASE_URL,
    //baseURL: 'http://localhost:8072/'   
    //baseURL: 'https://localhost:44304/api/'
    baseURL: 'https://catalogapi.smartauto-solutions.in/api/'
});

adminInstance.interceptors.request.use(
    (config) => {
        const authTokenDetail = sessionStorage.getItem('loginToken');
       // console.log(authTokenDetail);
    if (authTokenDetail) {
      config.headers['Authorization'] = `Bearer ${authTokenDetail}`;
    }
    config.headers['Access-Control-Allow-Origin'] = '*';

    if (!config.headers['Content-Type']) {
      config.headers['Content-Type'] = 'application/json';
    }
    //config.headers['Content-Type'] = 'application/json';
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// adminInstance.interceptors.response.use(
//   (response) => {
//     return response;
//   },
//   (error) => {
//     return Promise.reject(error);
//   }
// );

adminInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      localStorage.clear(); // optional: clear token/session
      window.location.href = '/login'; // redirect to login page
    }
    return Promise.reject(error);
  }
);


export { adminInstance };
